// Header definitions based on the table in the image
export const orderTrackingHeaders = {
  MSRef: {
    name: "MS No.",
    width: 0.3,
  },
  OrderNumber1: {
    name: "Order Number",
    width: 0.3,
  },
  allocateProductionLine: {
    name: "Production Line",
    width: 0.25,
  },
  ItemCode: {
    name: "Item Code",
    width: 0.3,
  },
  ItemName: {
    name: "Item Name",
    width: 0.65,
  },
  StateDelivery: {
    name: "State",
    width: 0.2,
  },
  OrderDate: {
    name: "PO Order Date",
    width: 0.3,
  },
  PriorityOrder: {
    name: "Priority Order",
    width: 0.25,
  },
  ArtworkNo: {
    name: "Artwork No",
    width: 0.2,
  },
  RequestDate: {
    name: "Due Date",
    width: 0.25,
  },
  TotalOrdered: {
    name: "Order Qty (Uom)",
    width: 0.3,
    textAlign: "center",
  },
  QtyToShip: {
    name: "Qty to Ship",
    width: 0.25,
  },
  FulfillmentPercent: {
    name: "Fulfilments %",
    width: 0.3,
  },
  // AusInventory: {
  //   name: "Aus Inventory",
  //   width: 0.25,
  // },
  Key: {
    name: "Key",
    width: 0.2,
    textAlign: "left",
    display: "hidden",
  },
  OrderStatus: {
    name: "Order Status",
    width: 0.2,
    textAlign: "left",
  },
  trackerActions_sm: {
    name: "",
    width: 0.2,
    textAlign: "center",
    justifyContent: "center",
  },
};

// Responsive headers for medium screens
export const mdOrderTrackingHeaders = {
  MSRef: {
    name: "MS No.",
    width: 0.4,
  },
  OrderNumber1: {
    name: "Order Number",
    width: 0.3,
  },
  allocateProductionLine: {
    name: "Production Line",
    width: 0.25,
  },
  ItemCode: {
    name: "Item Code",
    width: 0.3,
  },
  ItemName: {
    name: "Item Name",
    width: 0.65,
  },
  RequestDate: {
    name: "Due Date",
    width: 0.25,
  },
  TotalOrdered: {
    name: "Order Qty",
    width: 0.25,
    textAlign: "center",
  },
  QtyToShip: {
    name: "Qty to Ship",
    width: 0.25,
  },
  OrderStatus: {
    name: "Order Status",
    width: 0.2,
    textAlign: "left",
  },
  trackerActions: {
    name: "",
    width: 0.2,
    textAlign: "right",
    justifyContent: "center",
  },
};

// Responsive headers for small screens
export const smOrderTrackingHeaders = {
  MSRef: {
    name: "MS No.",
    width: 0.4,
  },
  OrderNumber1: {
    name: "Order Numnber",
    width: 0.3,
  },
  ItemCode: {
    name: "Item Code",
    width: 0.3,
  },
  ItemName: {
    name: "Item Name",
    width: 0.65,
  },
  OrderStatus: {
    name: "Order Status",
    width: 0.2,
    textAlign: "left",
  },
  trackerActions_sm: {
    name: "",
    width: 0.2,
    textAlign: "center",
    justifyContent: "center",
  },
};

export const nestedOrderTrackingHeaders = {
  runOrder: {
    name: "Run Order",
    width: 0.25,
  },
  directShipment: {
    name: "Direct Shipment",
    width: 0.3,
  },
  soakarPad: {
    name: "Soakar Pad",
    width: 0.3,
  },
  labelOrder: {
    name: "Label Ready",
    width: 0.3,
  },
  plannedQty: {
    name: "Planned Qty",
    width: 0.3,
  },
  duration: {
    name: "Duration (Days)",
    width: 0.3,
  },
  allocateProductionLine: {
    name: "Allocation Production Line",
    width: 0.3,
  },
  planStartDay: {
    name: "Planned Start Date",
    width: 0.2,
  },
  actualStartDay: {
    name: "Act. Start Date",
    width: 0.3,
  },
  ESTCompletionDate: {
    name: "Est.Completion",
    width: 0.25,
  },
  actualCompletionDate: {
    name: "Act. Completion",
    width: 0.3,
  },
  shippingDeadline: {
    name: "Shipping Deadline",
    width: 0.25,
  },
  ETD: {
    name: "ETD",
    width: 0.25,
  },
  ETA: {
    name: "ETA",
    width: 0.25,
  },
  ExpectedArrival: {
    name: "ETA (To Store)",
    width: 0.3,
  },
  actions: {
    name: "Actions",
    width: 0.3,
    textAlign: "center",
  },
};

export const mdNestedOrderTrackingHeaders = {
  plannedQty: {
    name: "Planned Qty",
    width: 0.3,
  },
  allocateProductionLine: {
    name: "A. Prod Line",
    width: 0.3,
  },
  planStartDay: {
    name: "Planned Start Date",
    width: 0.2,
  },
  actualStartDay: {
    name: "Act. Start Date",
    width: 0.3,
  },
  actions: {
    name: "Actions",
    width: 0.3,
    textAlign: "center",
  },
};

export const smNestedOrderTrackingHeaders = {
  plannedQty: {
    name: "Planned Qty",
    width: 0.3,
  },
  allocateProductionLine: {
    name: "A. Prod Line",
    width: 0.3,
  },
  actions: {
    name: "Actions",
    width: 0.3,
    textAlign: "center",
  },
};
